module.exports = __webpack_public_path__ + "img/facility9.4f7c2228.png";